import { atom } from "jotai";

export const appPortalAtom = atom(null as HTMLDivElement | null);
